import { StepEditorProps } from "../useStepEditor";
import { StepEditorAccordion } from "../../../workflows/routes/WorkflowEditor/StepEditorAccordion";
import { Block } from "../../../../components/atoms";
import { useStepOptions } from "../useStepOptions";
import { prefixForm } from "../../../../utils/FormUtils";
import { useDataSources } from "../../../datasources/hooks/useDataSources";
import { useMemo } from "react";
import { Field, Option, Select } from "@introist/react-foundation/v2";
import { TagAwareInput } from "modules/flows/components/TagAwareInput";

export const HibobUpdateStepEditor = ({ form, stepDataPath, workflowId }: StepEditorProps) => {
  const prefixedForm = prefixForm(form, stepDataPath);

  const { dataSources } = useDataSources();

  const { options } = useStepOptions(form.data.stepType, {
    datasourceId: prefixedForm.get("datasourceId")
  });

  const hibobSourceOptions = useMemo(() => {
    if (!dataSources) return [];
    return dataSources
      .filter(ds => ds.sourceType === "hibob")
      .map(s => ({ key: s.id, title: s.name }));
  }, [dataSources]);

  const fieldOptions: Option[] = useMemo(() => {
    if (!options || !options.fields) return [];
    // Group fields by category
    return options.fields.map((f: any) => ({
      key: f.jsonPath,
      title: `${f.name} (${f.category})`,
      metadata: f
    }));
  }, [options]);

  return (
    <>
      <Block blended compact>
        <StepEditorAccordion title="Target" defaultOpen>
          <StepEditorAccordion.Row label="Data source">
            <Select
              size="small"
              element="button"
              variant="blended"
              style={{ width: "100%" }}
              options={hibobSourceOptions}
              value={prefixedForm.get("datasourceId")}
              onSelect={opt => {
                prefixedForm.set("datasourceId")(opt.key);
                // Reset field selection when changing integration
                prefixedForm.set("fieldId")(undefined);
              }}
              placeholder="Select HiBob integration"
              attachToRef={false}
            />
          </StepEditorAccordion.Row>
          <StepEditorAccordion.Row label="Field">
            <Select
              size="small"
              element="button"
              variant="blended"
              style={{ width: "100%" }}
              options={fieldOptions}
              value={prefixedForm.get("fieldId")}
              onSelect={opt => prefixedForm.set("fieldId")(opt.key)}
              placeholder="Select field to update"
              attachToRef={false}
              disabled={!prefixedForm.get("datasourceId")}
              searchable
            />
          </StepEditorAccordion.Row>
        </StepEditorAccordion>
      </Block>
      <Block blended compact>
        <StepEditorAccordion title="Value" defaultOpen>
          <Field title="New value">
            <TagAwareInput
              value={prefixedForm.get("value")}
              onChange={prefixedForm.set("value")}
              error={prefixedForm.isError("value")}
              placeholder="Enter value or use tags"
              size="small"
              variant="blended"
              disabled={!prefixedForm.get("fieldId")}
              tagSelectContext={{ workflowId }}
            />
          </Field>
        </StepEditorAccordion>
      </Block>
    </>
  );
};
